





















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired, validateType } from '../UI/Form/Validations';
import PermissionService from '@/utils/permission-service';
import DeepCopy from '@/decorators/deep-copy';

@Component
export default class CarForm extends Vue {
  public PermissionService = PermissionService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public data!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public query!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData!: any;

  public validForm = true;

  public rules: IRules = {
    registrationNumber: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Car', 'registrationNumber') }),
    } ],
    name: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Car', 'name') }),
    } ],
    norwegianListPriceAsNew: [
      {
        validation: validateType('unumber'),
        message: i18n => i18n.t('GQL.Type.unumber'),
      },
    ],
  };

  @Emit()
  public mutationDone() {}
}
